<template>
  <div id="mng-feedbacks" class="py-8">

    <!-- lomakkeen otsikko -->
    <h2 class="txt-bold">Palautteet</h2>
    <span v-if="amountTotal" class="block mb-4 color-grey font-8">yht. {{ this.amountTotal }} kpl</span>

    <!-- keinolista / olemassa olevat keinot (EDIT) -->
    <div class="form-field mt-0 mb-6">
      <label for="is-context">Palautteen konteksti</label>
      <select name="is-context" v-model="isContext" class="rounded-5">
        <option value="all" selected="selected">--kaikki--</option>
        <option v-for="(context, index) in feedbackContexts" :key="index" class="color-black">{{ context }}</option>
      </select>
    </div>

    <hr class="border-0 border-t-l1 mb-1">

    <!-- palautteet -->
    <ul>
      <li
        v-for="(feedb, index) in feedbacks"
        :key="index"
        v-if="feedb.context === isContext || isContext === 'all'"
        class="relative py-3 px-1 border-b-l2"
      >
      <!-- em. lista kannattaisi toteuttaa luuppaamalla computed property, joka jaottelee luupattavat asiat ennalta (v-if poistuu) -->
        <h2 v-if="feedb.name" class="txt-bold font-10">{{feedb.name}}</h2>
        <h2 v-else class="color-grey-l2 txt-bold font-10">nimetön</h2>
        <span class="color-grey-l1 txt-bold font-8">{{feedb.time}}</span>
        <p class="mt-1">{{feedb.text}}</p>
        <i @click="deleteFeedbackItem(index, feedb.id)" class="material-icons absolute color-grey-l1 font-12" style="top: 10px; right: 5px;">delete</i>
      </li>
    </ul>

  </div>
</template>

<script>
import db from '@/firebase/init'

export default {
  name: 'mngFeedbacks',

  data () {
    return {
      feedbacks: [],
      feedbackContexts: this.$store.state.feedbackContexts,
      isContext: 'all'
    }
  },

  created () {
    db.collection('palaute').get().then(snapshot => {
      snapshot.docs.forEach(doc => {
        let palaute = doc.data()
        palaute.id = doc.id // tarvitaanko?
        this.feedbacks.push(palaute)
      })
    })
  },

  computed: {
    amountTotal () {
      return this.feedbacks.length
    }
  },

  methods: {
    deleteFeedbackItem (index, id) {
      // this.$delete(this.feedbacks, index)
      db.collection('palaute').doc(id).delete().then(() => {
        this.$delete(this.feedbacks, index)
      })
    }
  }
}
</script>

<style lang="scss">
</style>
